import { inject, Injectable } from '@angular/core';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { CookieKey } from '../types/cookie-key';

export type UserSettings = {
  listingLayout: 'dense' | 'normal';
  isLocaleSetByUser: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  private readonly cookies = inject(SsrCookieService);
  private readonly settings = this.getSettings();

  get<K extends keyof UserSettings>(key: K): UserSettings[K] {
    return this.settings[key];
  }

  set<K extends keyof UserSettings>(key: K, value: UserSettings[K]): void {
    const now = new Date();
    const expires = new Date(now.setFullYear(now.getFullYear() + 1));
    this.settings[key] = value;
    this.cookies.set(CookieKey.UserSettings, JSON.stringify(this.settings), {
      expires,
      path: '/',
    });
  }

  private getSettings(): UserSettings {
    try {
      return JSON.parse(this.cookies.get(CookieKey.UserSettings));
    } catch {
      return {
        listingLayout: 'dense',
        isLocaleSetByUser: false,
      };
    }
  }
}
